import React, { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import { FaEye, FaTrash } from "react-icons/fa";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import Correct from "../../../assets/Icons/correct.svg";
import DownloadIcon from "../../../assets/Icons/download.svg";
import PageIcon from "../../../assets/Icons/page.svg";

const FranchiseUploadDocument = ({ show, handleClose, columnData }) => {
  const [files, setFiles] = useState({
    gstCertificate: null,
    retailerIncorporation: null,
    aadharFront: null,
    aadharBack: null,
    retailerPan: null,
    authPersonPan: null,
    boardResolution: null,
  });

  // Function to extract filename from URL - handles query parameters
  const extractFileNameFromUrl = (url) => {
    if (!url) return "";

    try {
      // Create URL object to parse the URL
      const urlObj = new URL(url);

      // Check if filename is in query parameters
      const fileNameParam = urlObj.searchParams.get("fileName");
      if (fileNameParam) {
        return decodeURIComponent(fileNameParam);
      }

      // If no fileName param, extract from path
      const pathParts = urlObj.pathname.split("/");
      const lastPart = pathParts.pop();

      // If the last part is empty (trailing slash), get the previous part
      const filename = lastPart || pathParts.pop() || "";

      return decodeURIComponent(filename);
    } catch (error) {
      // If URL parsing fails, try simple extraction
      console.log("URL parsing error, trying fallback:", error);

      // Try to extract from query string first
      const queryMatch = url.match(/[?&]fileName=([^&]+)/);
      if (queryMatch && queryMatch[1]) {
        return decodeURIComponent(queryMatch[1]);
      }

      // Fallback: split by '/' and get last part
      const parts = url.split("/");
      let filename = parts.pop() || parts.pop() || "";

      // Remove query string from filename if present
      filename = filename.split("?")[0];

      return decodeURIComponent(filename);
    }
  };

  // Function to create file object from backend data
  const createFileObject = (filePath, fileSize) => {
    if (!filePath) return null;

    return {
      url: filePath,
      name: extractFileNameFromUrl(filePath),
      size: fileSize,
    };
  };

  // ✅ Pre-fill from backend response
  useEffect(() => {
    if (columnData) {
      setFiles({
        gstCertificate: createFileObject(
          columnData.gstCertificateFilePath,
          columnData.gstCertificateFileSize
        ),
        retailerIncorporation: createFileObject(
          columnData.incorporationCertificateFilePath,
          columnData.incorporationCertificateFileSize
        ),
        aadharFront: createFileObject(
          columnData.aadharFrontFilePath,
          columnData.aadharFrontFileSize
        ),
        aadharBack: createFileObject(
          columnData.aadharBackFilePath,
          columnData.aadharBackFileSize
        ),
        retailerPan: createFileObject(
          columnData.panFilePath,
          columnData.panFileSize
        ),
        authPersonPan: createFileObject(
          columnData.authPersonPanFilePath,
          columnData.authPersonPanFileSize
        ),
        boardResolution: createFileObject(
          columnData.boardResolutionFilePath,
          columnData.boardResolutionFileSize
        ),
      });
    }
  }, [columnData]);

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      // Create object with actual file data
      const fileObject = {
        file, // Original file object
        name: file.name, // Actual filename
        size: file.size, // Actual file size
        url: URL.createObjectURL(file), // Preview URL
      };
      setFiles((prev) => ({ ...prev, [field]: fileObject }));
    }
  };

  const handleDelete = (field) => {
    // Revoke object URL to prevent memory leaks
    if (
      files[field] &&
      files[field].url &&
      files[field].url.startsWith("blob:")
    ) {
      URL.revokeObjectURL(files[field].url);
    }
    setFiles((prev) => ({ ...prev, [field]: null }));
  };

  const allUploaded = Object.values(files).every((file) => file !== null);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1031,
      }}
    >
      <div className="bg-white w-[35%] min-w-[30%] h-[671px] rounded-2xl shadow-lg relative">
        <img
          src={LeftCircle}
          alt="leftImg"
          className="absolute left-0 bottom-0 w-[110px] h-[105px]"
        />
        <img
          src={RightCircle}
          alt="leftImg"
          className="absolute right-0 top-0 w-[110px] h-[105px]"
        />
        {/* Header */}
        <div className="flex justify-between items-center px-4 pt-4 pb-2">
          <div className="flex items-center">
            <img
              src={DownloadIcon}
              alt="DownloadIcon"
              className="w-10 h-10 mr-2"
            />
            <h2 className="text-xl font-semibold text-orange-600">
              Upload File
            </h2>
          </div>
          <button onClick={handleClose} className="z-20">
            <IoClose className="text-2xl text-gray-600 hover:text-black cursor-pointer" />
          </button>
        </div>

        {/* File Upload List */}
        <div className="px-4 pb-4 overflow-y-auto custom-scrollbar h-[540px]">
          {[
            { label: "GST Certificate", key: "gstCertificate" },
            {
              label: "Franchise incorporation certificate",
              key: "retailerIncorporation",
            },
            { label: "Aadhar front copy", key: "aadharFront" },
            { label: "Aadhar back copy", key: "aadharBack" },
            { label: "Franchise PAN card", key: "retailerPan" },
            { label: "Authorize Person PAN card", key: "authPersonPan" },
            { label: "Board Resolution", key: "boardResolution" },
          ].map(({ label, key }) => (
            <div
              key={key}
              className="border rounded-xl p-[0.5rem] mt-3 flex justify-between items-center"
            >
              <div className="flex gap-2 items-center">
                <img
                  src={PageIcon}
                  alt="DownloadIcon"
                  className="w-10 h-10 mr-2"
                />
                <div>
                  <p className="font-medium text-sm text-gray-700">{label}</p>
                  {files[key] ? (
                    <div className="text-sm flex flex-col mt-1">
                      <div className="flex gap-10">
                        <span className="text-[#6a7282] text-sm">
                          {files[key].size
                            ? `${(files[key].size / 1024).toFixed(1)} KB`
                            : "N/A"}
                        </span>
                        <div className="flex gap-1 items-center text-green-600">
                          <img alt="Success" src={Correct} />
                          <span>Uploaded</span>
                        </div>
                      </div>
                      {/* This will now show the actual filename */}
                      <span className="text-gray-500 text-sm truncate max-w-[200px] block">
                        📄 {files[key]?.name || "No filename available"}
                      </span>
                    </div>
                  ) : (
                    <p className="text-sm text-gray-400">No file uploaded</p>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-3">
                {files[key] ? (
                  <>
                    <FaEye
                      className="text-gray-600 cursor-pointer hover:text-orange-500"
                      onClick={() => {
                        if (files[key].url) {
                          window.open(files[key].url, "_blank");
                        }
                      }}
                    />
                    <FaTrash
                      className="text-red-500 cursor-pointer hover:text-red-700"
                      onClick={() => handleDelete(key)}
                    />
                  </>
                ) : (
                  <>
                    <label className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-1 rounded-md cursor-pointer text-sm">
                      Upload
                      <input
                        type="file"
                        className="hidden"
                        onChange={(e) => handleFileChange(e, key)}
                      />
                    </label>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Submit Button */}
        <div className="flex justify-center">
          <button
            className="btn btn-submit w-[92%] h-[37px] !rounded-[8px] flex items-center justify-center"
            disabled={!allUploaded}
            onClick={() => alert("Submitted successfully!")}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default FranchiseUploadDocument;
